const vehicleData = {
  street: {
    Mustang: {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/first-gen-mustang-v3.jpg',
      shopUrl: '/shop/ford-mustang~96-54-688',
    },
    Camaro: {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/first-gen-camaro.jpg',
      shopUrl: '/shop/chevy-camaro~96-47-432',
    },
    C10: {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/c10-cat-img.jpg',
      shopUrl: '/shop/chevy-c10~96-47-422',
    },
    'F Series Truck': {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/f-series-cat-img.jpg',
      shopUrl: '/shop/f-series~8388608-59',
    },
    Chevelle: {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/chevelle-cat-img.jpg',
      shopUrl: '/shop/chevy-chevelle~96-47-21448',
    },
    'Tri Five': {
      imageUrl: 'https://content.speedwaymotors.com/CategorizationImages/tri-five-cat-image.jpg',
      shopUrl: '/shop/tri-five~8454272-1-949-20',
    },
  },
  race: {
    'Stock Car': {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/Racetype_Small_StockCar.jpg',
      shopUrl: '/shop/stock-car~65920-2-2-11',
    },
    Modified: {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/RaceType_Modified_2018_04_25.jpg',
      shopUrl: '/shop/modified~65920-2-2-6',
    },
    'Hobby Stock': {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/Racetype_Small_HobbyStock.jpg',
      shopUrl: '/shop/hobby-stock~65920-2-2-15',
    },
    'Street/Strip': {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/street-strip-drag-tile.jpg',
      shopUrl: '/shop/street-strip~65920-2-1775-27',
    },
    'Sprint Car': {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/Racetype_Small_SprintCar.jpg',
      shopUrl: '/shop/sprint-car~65920-2-2-10',
    },
    'Dirt Late Model': {
      imageUrl: 'https://content.speedwaymotors.com/Shop/Images/Race/Racetype_Small_DirtLateModel.jpg',
      shopUrl: '/shop/dirt-late-model~65920-2-2-1',
    },
  },
}

export default vehicleData
